import PropTypes from 'prop-types';
import { rgba } from 'polished';

function Base({ children, color, bold, italic, weak, fontSize }) {
  const _colorSelect = () => {
    if (color) {
      if (weak) {
        return rgba(color, 0.5);
      } else {
        return color;
      }
    } else {
      if (weak) {
        return '#959595';
      } else {
        return '#000000';
      }
    }
  };
  return (
    <span
      style={{
        fontSize: fontSize || '16px',
        fontWeight: bold ? 'bold' : 'normal',
        fontStyle: italic ? 'italic' : 'normal',
        fontFamily: 'Source Sans Pro',
        textDecoration: 'none',
        color: _colorSelect(),
        opacity: 1,
      }}
    >
      {children}
    </span>
  );
}

export function Default(props) {
  return Base({
    ...props,
    fontSize: '16px',
  });
}

export function DefaultSmall(props) {
  return Base({
    ...props,
    fontSize: '14px',
  });
}

export function DefaultXSmall(props) {
  return Base({
    ...props,
    fontSize: '12px',
  });
}

export function DefaultLarge(props) {
  return Base({
    ...props,
    fontSize: '18px',
  });
}

export function DefaultXLarge(props) {
  return Base({
    ...props,
    fontSize: '20px',
  });
}

Default.propTypes =
  DefaultSmall.propTypes =
  DefaultXSmall.propTypes =
  DefaultLarge.propTypes =
  DefaultXLarge.propTypes =
    {
      children: PropTypes.string.isRequired,
      color: PropTypes.string,
      bold: PropTypes.bool,
      italic: PropTypes.bool,
      weak: PropTypes.bool,
    };
